var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalisis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.197,
    height: 82.197,
    viewBox: "0 0 82.197 82.197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "analisis") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.032,34.2a1.725,1.725,0,1,0-1.725,1.726A1.726,1.726,0,0,0,29.032,34.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.658,42.825a1.725,1.725,0,1,0-1.725,1.726A1.726,1.726,0,0,0,37.658,42.825Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6,50.281c-.1.131-.211.26-.319.387q-.237.283-.484.558c-.086.094-.172.184-.258.276q-.5.531-1.028,1.028c-.092.086-.182.172-.276.259q-.275.246-.558.483c-.129.108-.267.223-.387.319s-.234.2-.356.291l2.388,2.388,3.956-3.956L53.89,49.926C53.8,50.048,53.694,50.162,53.6,50.281Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.284,
    cy: 32.474,
    r: 1.725,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.734,32.474a3.429,3.429,0,0,1-5.192,2.962l-5.648,5.647a3.407,3.407,0,0,1,.489,1.742,3.451,3.451,0,1,1-6.9,0,3.407,3.407,0,0,1,.489-1.742l-3.923-3.922a3.406,3.406,0,0,1-1.741.488,3.448,3.448,0,0,1-3.328-2.587H20.5a16.192,16.192,0,0,0-.092,1.748,16.387,16.387,0,1,0,30.719-7.957l-1.88,1.879A3.407,3.407,0,0,1,49.734,32.474Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.36,18.672A1.726,1.726,0,1,0,60.085,20.4,1.726,1.726,0,0,0,58.36,18.672Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.486,64.434l.045.045a2.8,2.8,0,0,0,3.91-4L57.5,53.534,53.542,57.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8,20.4a16.415,16.415,0,0,0-16.017,12.94h3.2a3.443,3.443,0,0,1,6.778.862,3.407,3.407,0,0,1-.489,1.742l3.923,3.923a3.346,3.346,0,0,1,3.483,0l5.648-5.648a3.407,3.407,0,0,1-.489-1.742,3.45,3.45,0,0,1,3.451-3.45,3.4,3.4,0,0,1,1.739.492l2.156-2.157A16.373,16.373,0,0,0,36.8,20.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1,0A41.1,41.1,0,1,0,82.2,41.1,41.1,41.1,0,0,0,41.1,0ZM66.986,21.26h-5.3a3.45,3.45,0,0,1-3.328,2.588,3.4,3.4,0,0,1-1.74-.49l-1.726,1.725a21.491,21.491,0,0,1,0,23.408l2.6,2.6,1.219,1.22,6.944,6.944a4.522,4.522,0,0,1-6.4,6.4l-6.944-6.944L51.1,57.49l-2.6-2.6a21.565,21.565,0,1,1,5.384-31.231L55.4,22.139A3.4,3.4,0,0,1,54.91,20.4a3.443,3.443,0,0,1,6.778-.862h5.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.213,20.587a19.871,19.871,0,0,0,23.1,32.338c.38-.272.751-.552,1.109-.848.105-.087.206-.181.308-.267.309-.265.606-.537.894-.818.126-.123.251-.247.374-.374q.421-.432.817-.893c.089-.1.182-.2.268-.308.3-.358.576-.73.848-1.11a19.871,19.871,0,0,0-27.72-27.72ZM36.8,54.9A18.115,18.115,0,1,1,54.91,36.787,18.114,18.114,0,0,1,36.8,54.9Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalisis);
export default __webpack_public_path__ + "static/media/analisis.6fa01892a2e23ab6f167c452cb387043.svg";
export { ForwardRef as ReactComponent };